class saveRecentlyViewedProduct {
    constructor(productID) {
        this.id = productID;

        if (this.id) {
            this.save();
        }

    }

    save() {
        try {
            let recentlyViewedProducts = JSON.parse(
                localStorage.getItem('recently-viewed-products') || '[]'
            );

            recentlyViewedProducts = recentlyViewedProducts.filter(item => item !== this.id);
            recentlyViewedProducts.unshift(this.id);

            localStorage.setItem('recently-viewed-products', JSON.stringify(recentlyViewedProducts));
        } catch (e) {
            console.error("saveRecentlyViewedProduct:", e);
        }
    }
}

export {
    saveRecentlyViewedProduct
}
